module.exports = __webpack_public_path__ + "zvetseni-prsou_37_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_37_after.jpg
// module id = 1329
// module chunks = 0